export default "__VITE_ASSET__DWAxYK4q__"